var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2695_10307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4DA0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.05882C15.5583 7.24412 15.0822 7.36588 14.5889 7.42412C15.0937 7.14353 15.4837 6.69882 15.6673 6.16412C15.1912 6.42882 14.6635 6.61412 14.1071 6.72C13.6539 6.26471 13.0172 6 12.2945 6C10.9465 6 9.84512 7.01647 9.84512 8.27118C9.84512 8.45118 9.86807 8.62588 9.90822 8.79C7.86616 8.69471 6.0478 7.78941 4.83748 6.41824C4.62524 6.75176 4.50478 7.14353 4.50478 7.55647C4.50478 8.34529 4.93499 9.04412 5.60038 9.44118C5.19312 9.44118 4.81453 9.33529 4.48184 9.17647V9.19235C4.48184 10.2935 5.33078 11.2147 6.45507 11.4212C6.09411 11.5123 5.71516 11.525 5.34799 11.4582C5.50379 11.9095 5.80891 12.3045 6.22047 12.5874C6.63202 12.8704 7.12932 13.0272 7.64245 13.0359C6.77264 13.6714 5.69445 14.0149 4.58509 14.01C4.39006 14.01 4.19503 13.9994 4 13.9782C5.08987 14.6241 6.38623 15 7.77438 15C12.2945 15 14.7782 11.5376 14.7782 8.53588C14.7782 8.43529 14.7782 8.34 14.7725 8.23941C15.2543 7.92176 15.6673 7.51941 16 7.05882Z",
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2695_10307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterContact);
export default __webpack_public_path__ + "static/media/twitter_contact.2bf5cc2ff3ecbd25763055e5a47e8a7d.svg";
export { ForwardRef as ReactComponent };